import React, { useContext, useEffect, useState } from 'react'
import { Input } from './Shared'
import EstContext from '../Context/EstContext'


const PaperSelect = ({list,value,listid,placeholder,required,border,disabled,MB,option,index}) => {

    const {info,paperlist,setInfo} = useContext(EstContext)


    
    //    //setInfo(jj)

    const setitem = async(e) => {
        console.log(index)
     let inputValue = e.target.value;

let id;
   let stockid
   let weight
   let cwt
   let perthou
   let divide
   let category
   const jj = {...info}
   let h = jj.options[option]
var options = document.getElementById(listid).childNodes;
for (var i = 0; i < options.length; i++) {
                  if (options[i].value === inputValue) {
                  id = (options[i].dataset.item)
                  stockid = (options[i].dataset.stockid)
                  weight = (options[i].dataset.weight)
                  cwt = (options[i].dataset.cwt)
                  perthou = (options[i].dataset.perthou)
                  divide = (options[i].dataset.divide)
                  category = (options[i].dataset.category)
                  }}
if(id){

   
    h.forms[index].papername = inputValue
    h.forms[index].paperstockid = id
    h.forms[index].paperid = stockid
    h.forms[index].paperweight = weight
    h.forms[index].papercwt = cwt
    h.forms[index].paperperthou = perthou
    h.forms[index].paperdivide = divide
    h.forms[index].papercategory = category
    setInfo(jj)
}else{
    h.forms[index].papername = inputValue
    h.forms[index].paperstockid = ""
    h.forms[index].paperid = ""
    h.forms[index].paperweight = ""
    h.forms[index].papercwt = ""
    h.forms[index].paperperthou = ""
    h.forms[index].paperdivide = ""
    h.forms[index].papercategory = category
    setInfo(jj)
}




//      
//               itemindex = (options[i].dataset.itemindex)
//               }}
//               if(id){
//                 setValue({id,name:inputValue,stockid,itemindex})
      
//               }else{
//                 setValue({id:null,name:inputValue,stockid,itemindex})
//               }
             
            }


  return (
   <>
   <Input marginBottom={MB} type="text" border={border} placeholder={placeholder} value={value} list={listid} onChange={e => setitem(e,index)} />

   <datalist id={listid}>
{
    list?.map((item,index) => {
     return   <option key={index} data-item={item._id} data-index={index} data-category={item?.category} data-stockid={item.stockid} data-cwt={item.cwt} data-divide={item.divide} data-weight={item.weight} data-perthou={item.perthou} value={item.stockid > 0 ? `${item.name} - ${item.kind}` : item.name} /> 
    })
}
   </datalist>
   </>
  )
}

export default PaperSelect